var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.6167C0 11.1411 0.214025 10.6869 0.590909 10.3627L12.3957 0.206351C12.7434 -0.068784 13.2566 -0.0687837 13.6043 0.206352L25.4091 10.3627C25.7861 10.6869 26 11.1411 26 11.6167V21.4286C26 22.8487 24.7527 24 23.2143 24H2.78571C1.24721 24 0 22.8487 0 21.4286V11.6167ZM12.5739 14.9996L12.5349 14.9991H10.219V9.85618H15.7911V14.9991H13.4643L13.4253 14.9996H12.5739ZM8.81448 21.8563L8.85346 21.8568H9.70487L9.74385 21.8563H12.0706V16.7134H6.49859V21.8563H8.81448ZM16.2834 21.8568L16.2445 21.8563H13.9286V16.7134H19.5006V21.8563H17.1738L17.1349 21.8568H16.2834Z",
    fill: "#2c9961"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.e8d73cc2ed3489e2c0e92b19f92577e5.svg";
export { ForwardRef as ReactComponent };